import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProjectProvider } from '../context/ProjectContext';
import ProjectHub from './ProjectHub';

const ProjectHubWrapper = () => {
  return (
    <Routes>
      <Route path="/" element={
        <ProjectProvider>
          <ProjectHub />
        </ProjectProvider>
      } />
      <Route path="/cross-projects" element={
        <ProjectProvider>
          <ProjectHub />
        </ProjectProvider>
      } />
      <Route path="/configuration" element={
        <ProjectProvider>
          <ProjectHub />
        </ProjectProvider>
      } />
      <Route path="/projects/:projectId" element={
        <ProjectProvider>
          <ProjectHub />
        </ProjectProvider>
      } />
      <Route path="/projects/:projectId/:tab" element={
        <ProjectProvider>
          <ProjectHub />
        </ProjectProvider>
      } />
      <Route path="/folders/:folderId" element={
        <ProjectProvider>
          <ProjectHub />
        </ProjectProvider>
      } />
    </Routes>
  );
};

export default ProjectHubWrapper;
